import { MY_FLIGHT_PANEL } from '../../constants/common/common.constants';
import {
  AuxiliaryNavigationAemItem,
  HeaderFooterMachCore,
  MyFlightPanelAem,
  PrimaryNavigationAemItem,
  SecondaryNavigationAem
} from '../../models/header-footer-mach-core';

export const getIsDelta = (
  contentHeaderFooter: HeaderFooterMachCore
): boolean => {
  const flightPanelObject = getAuxiliaryNavigation(
    contentHeaderFooter,
    MY_FLIGHT_PANEL
  ) as MyFlightPanelAem;
  return flightPanelObject && flightPanelObject.accountOverview === 'true'
    ? true
    : false;
};

export const getAuxiliaryNavigation = (
  content: HeaderFooterMachCore,
  id: string
): AuxiliaryNavigationAemItem | undefined => {
  return content.header?.auxiliaryNavigation.find(
    (element) => element.id === id
  );
};

export const getPrimaryNavigationId = (
  content: HeaderFooterMachCore,
  id: string
): PrimaryNavigationAemItem | undefined => {
  return content.header?.primaryNavigation.find((element) => element.id === id);
};

export const getSecondaryNavigationId = (
  content: HeaderFooterMachCore,
  id: string
): SecondaryNavigationAem | undefined => {
  return content.header?.secondaryNavigation.find(
    (element) => element.id === id
  );
};
